import type { EventHookOn } from '@vueuse/core';
import type { Eva2Error } from '~/lib/errors/Eva2Error';

export enum FormStrategyType {
  SingleStep = 'single-step',
  MultiStep = 'multi-step',
}

export type UseFormStrategy = {
  fetch: (body?: any) => Promise<void>;
  step: ComputedRef<any>;
  index: Ref<number>;
  count: Ref<number>;
  title: ComputedRef<string>;
  fields: ComputedRef<FormField[]>;
  hasPrevious: ComputedRef<boolean>;
  hasCancel: ComputedRef<boolean>;
  formFieldsData: UseFormFieldsData;
  formFieldsValidation: UseFormFieldsValidation;
  formFieldsRecap: UseFormFieldsRecap;
  ready: ComputedRef<boolean>;
  completed: Ref<boolean>;
  updated: Ref<boolean>;
  gotoStep: (stepId: string) => void;
  submit: () => void;
  previous: () => void;
  loading: Ref<boolean>;
  hasFieldsReaquired: ComputedRef<boolean>;
  onSubmitComplete: EventHookOn<any>;
  checkValidatedFormOnMounted: Ref<boolean>;
  getSubmitBody: () => any;
  formNavigation: UseFormNavigationObserver;
  releaseError: () => void;
  error: Ref<Eva2Error>;
  context: MultiStepContext | SingleStepContext;
};

// synchroUserFrequency
export const useFormStrategy = (
  context: MultiStepContext | SingleStepContext
): UseFormStrategy => {
  switch (context.type) {
    case FormStrategyType.SingleStep:
      return useFormStrategySingleStep(context as SingleStepContext);

    default:
      return useFormStrategyMultiStep(context as MultiStepContext);
  }
};
